class ScrollPrompt extends HTMLElement {
  connectedCallback() {
    this.threshold = Number(this.dataset.threshold) || 100;
    this.observeSelector = this.dataset.observe || '#feed > a';
    this.hidden = null;
    this.visibleCards = new Set();

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initObservers(), { once: true });
    } else {
      this.initObservers();
    }

    this.updateVisibility();
  }

  initObservers() {
    this.cards = document.querySelectorAll(this.observeSelector);

    if (!this.cards.length) return;

    this.observer = new IntersectionObserver(
      this.onCardsIntersect.bind(this),
      { threshold: 0 }
    );
    this.cards.forEach((card) => this.observer.observe(card));
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.observer?.disconnect();
  }

  onCardsIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.visibleCards.add(entry.target);
      } else {
        this.visibleCards.delete(entry.target);
      }
    });

    this.updateVisibility();
  }

  onScroll() {
    this.updateVisibility();
  }

  updateVisibility() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const shouldHide = scrollTop > this.threshold || this.visibleCards.size > 0;

    if (shouldHide === this.hidden) return;

    this.hidden = shouldHide;
    this.classList.toggle('scroll-prompt--hidden', shouldHide);
  }
}

if (!customElements.get('scroll-prompt')) {
  customElements.define('scroll-prompt', ScrollPrompt);
}
